/**
 * Bar feature fields with labels and emojis
 */
export const featureFields = [
  { key: 'acceptsVR', label: 'Aceita VR', emoji: '💳' },
  { key: 'hasDrinks', label: 'Tem drinks', emoji: '🍹' },
  { key: 'hasBottleBeer', label: 'Cerveja de garrafa', emoji: '🍺' },
  { key: 'hasLatao', label: 'Latão', emoji: '🥫' },
  { key: 'hasChopp', label: 'Chopp', emoji: '🍻' },
  { key: 'openAfterMidnight', label: 'Depois da meia-noite', emoji: '🌙' },
  { key: 'worksOnRain', label: 'Funciona com chuva', emoji: '🌧️' },
  { key: 'goodForDate', label: 'Bom pra date', emoji: '💘' },
  { key: 'hasLiveMusic', label: 'Música ao vivo', emoji: '🎸' },
  { key: 'hasSeating', label: 'Lugar pra sentar', emoji: '🪑' },
  { key: 'acceptsReservations', label: 'Aceita reserva', emoji: '📅' },
  { key: 'isPuzzlePub', label: 'Jogos de tabuleiro', emoji: '🎲' },
  { key: 'hasKaraoke', label: 'Karaokê', emoji: '🎤' },
  { key: 'veganFriendly', label: 'Opções veganas', emoji: '🌱' },
  { key: 'childFriendly', label: 'Espaço kids', emoji: '👶' },
  { key: 'freeEntrance', label: 'Entrada grátis', emoji: '🆓' }
];

/**
 * Music style options (multi-select)
 */
export const musicStyleOptions = [
  { value: 'samba', label: 'Samba' },
  { value: 'sertanejo', label: 'Sertanejo' },
  { value: 'rock', label: 'Rock' },
  { value: 'pagode', label: 'Pagode' },
  { value: 'funk', label: 'Funk' },
  { value: 'forro', label: 'Forró' },
  { value: 'mpb', label: 'MPB' },
  { value: 'eletronica', label: 'Eletrônica' },
  { value: 'diversos', label: 'Diversos' },
  { value: 'outro', label: 'Outro' }
];

/**
 * Empty bar form initial state
 */
export const emptyBarForm = {
  name: '',
  neighborhood: '',
  notes: '',
  musicStyles: [],
  acceptsVR: false,
  hasDrinks: false,
  hasBottleBeer: false,
  hasLatao: false,
  hasChopp: false,
  openAfterMidnight: false,
  worksOnRain: false,
  goodForDate: false,
  hasLiveMusic: false,
  hasSeating: false,
  acceptsReservations: false,
  isPuzzlePub: false,
  hasKaraoke: false,
  veganFriendly: false,
  childFriendly: false,
  freeEntrance: false
};

/**
 * Format name to show last name as initials
 * Only applies formatting if first and last names are properly capitalized
 * Example: "John Doe" -> "John D."
 * Example: "john doe" -> "john doe" (not capitalized, return as-is)
 * Example: "Maria" -> "Maria"
 * Example: "João Pedro Silva" -> "João Pedro S."
 */
export function formatNameWithInitials(name) {
  if (!name || typeof name !== 'string') return name;

  const parts = name.trim().split(/\s+/);
  if (parts.length === 1) return parts[0];

  const lastName = parts[parts.length - 1];
  const firstNames = parts.slice(0, -1);

  // Check if first name and last name start with uppercase
  const firstNameCapitalized = firstNames.every(n => n.length > 0 && n[0] === n[0].toUpperCase());
  const lastNameCapitalized = lastName.length > 0 && lastName[0] === lastName[0].toUpperCase();

  // Only apply initials format if both are properly capitalized
  if (firstNameCapitalized && lastNameCapitalized) {
    return `${firstNames.join(' ')} ${lastName.charAt(0).toUpperCase()}.`;
  }

  // Otherwise return the full name as-is
  return name;
}

/**
 * Get only the first name
 * Example: "John Doe" -> "John"
 * Example: "Maria" -> "Maria"
 */
export function getFirstName(name) {
  if (!name || typeof name !== 'string') return 'Usuário';

  const parts = name.trim().split(/\s+/);
  return parts[0];
}

/**
 * Format music styles for display
 * Returns the label(s) separated by comma
 */
export function formatMusicStyles(musicStyles) {
  if (!musicStyles || !Array.isArray(musicStyles) || musicStyles.length === 0) {
    return null;
  }

  return musicStyles
    .map(value => {
      const option = musicStyleOptions.find(opt => opt.value === value);
      return option ? option.label : value;
    })
    .join(', ');
}
